// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../reason/next/Next.bs.js");
let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Stdlib_Int = require("@rescript/runtime/lib/js/Stdlib_Int.js");
let Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
let FormalityUI = require("../common/Form/FormalityUI.bs.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
let CreateTeamMarketingProfileMutation_graphql = require("../../__generated__/CreateTeamMarketingProfileMutation_graphql.bs.js");

let validators_teamSize = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let teamSize = param.teamSize;
    if (teamSize === "") {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
    let n = Stdlib_Int.fromString(teamSize, undefined);
    if (n !== undefined) {
      return {
        TAG: "Ok",
        _0: n
      };
    } else {
      return {
        TAG: "Error",
        _0: "NotANumber"
      };
    }
  }
};

let validators_website = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let website = param.website;
    if (website === "") {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
    let e = Scalars.URL.fromString(website);
    if (e.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: Primitive_option.some(e._0)
      };
    } else {
      return {
        TAG: "Error",
        _0: "InvalidURL"
      };
    }
  }
};

let validators_teamName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let teamName = param.teamName;
    if (teamName === "") {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    } else {
      return {
        TAG: "Ok",
        _0: teamName
      };
    }
  }
};

let validators = {
  teamSize: validators_teamSize,
  website: validators_website,
  brokerage: undefined,
  teamName: validators_teamName
};

function initialFieldsStatuses(input) {
  return {
    teamSize: "Pristine",
    website: "Pristine",
    brokerage: "Pristine",
    teamName: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    teamSize: "Pristine",
    website: "Pristine",
    brokerage: "Pristine",
    teamName: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      teamSize: "Pristine",
      website: "Pristine",
      brokerage: "Pristine",
      teamName: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match = fieldsStatuses.teamSize;
  let tmp;
  tmp = typeof match !== "object" ? validators.teamSize.validate(input) : match._0;
  let match$1 = fieldsStatuses.website;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.website.validate(input) : match$1._0;
  let match_0 = {
    TAG: "Ok",
    _0: input.brokerage
  };
  let match$2 = fieldsStatuses.teamName;
  let tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.teamName.validate(input) : match$2._0;
  let teamSizeResult = tmp;
  let teamSizeResult$1;
  if (teamSizeResult.TAG === "Ok") {
    let websiteResult = tmp$1;
    if (websiteResult.TAG === "Ok") {
      let brokerageResult = match_0;
      if (brokerageResult.TAG === "Ok") {
        let teamNameResult = tmp$2;
        if (teamNameResult.TAG === "Ok") {
          return {
            TAG: "Valid",
            output: {
              teamName: teamNameResult._0,
              brokerage: brokerageResult._0,
              website: websiteResult._0,
              teamSize: teamSizeResult._0
            },
            fieldsStatuses: {
              teamSize: {
                TAG: "Dirty",
                _0: teamSizeResult,
                _1: "Shown"
              },
              website: {
                TAG: "Dirty",
                _0: websiteResult,
                _1: "Shown"
              },
              brokerage: {
                TAG: "Dirty",
                _0: brokerageResult,
                _1: "Hidden"
              },
              teamName: {
                TAG: "Dirty",
                _0: teamNameResult,
                _1: "Shown"
              }
            },
            collectionsStatuses: undefined
          };
        }
        teamSizeResult$1 = teamSizeResult;
      } else {
        teamSizeResult$1 = teamSizeResult;
      }
    } else {
      teamSizeResult$1 = teamSizeResult;
    }
  } else {
    teamSizeResult$1 = teamSizeResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      teamSize: {
        TAG: "Dirty",
        _0: teamSizeResult$1,
        _1: "Shown"
      },
      website: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      },
      brokerage: {
        TAG: "Dirty",
        _0: match_0,
        _1: "Hidden"
      },
      teamName: {
        TAG: "Dirty",
        _0: tmp$2,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurTeamSizeField" :
          let result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.teamSize, validators_teamSize, status => {
            let init = state.fieldsStatuses;
            return {
              teamSize: status,
              website: init.website,
              brokerage: init.brokerage,
              teamName: init.teamName
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurWebsiteField" :
          let result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.website, validators_website, status => {
            let init = state.fieldsStatuses;
            return {
              teamSize: init.teamSize,
              website: status,
              brokerage: init.brokerage,
              teamName: init.teamName
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurBrokerageField" :
          let result$2 = Formality.validateFieldOnBlurWithoutValidator(state.input.brokerage, state.fieldsStatuses.brokerage, status => {
            let init = state.fieldsStatuses;
            return {
              teamSize: init.teamSize,
              website: init.website,
              brokerage: status,
              teamName: init.teamName
            };
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurTeamNameField" :
          let result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.teamName, validators_teamName, status => {
            let init = state.fieldsStatuses;
            return {
              teamSize: init.teamSize,
              website: init.website,
              brokerage: init.brokerage,
              teamName: status
            };
          });
          if (result$3 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$3,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateTeamSizeField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.teamSize, state.submissionStatus, validators_teamSize, status => {
                let init = state.fieldsStatuses;
                return {
                  teamSize: status,
                  website: init.website,
                  brokerage: init.brokerage,
                  teamName: init.teamName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateWebsiteField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.website, state.submissionStatus, validators_website, status => {
                let init = state.fieldsStatuses;
                return {
                  teamSize: init.teamSize,
                  website: status,
                  brokerage: init.brokerage,
                  teamName: init.teamName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateBrokerageField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$2.brokerage, status => {
                let init = state.fieldsStatuses;
                return {
                  teamSize: init.teamSize,
                  website: init.website,
                  brokerage: status,
                  teamName: init.teamName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateTeamNameField" :
          let nextInput$3 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$3,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.teamName, state.submissionStatus, validators_teamName, status => {
                let init = state.fieldsStatuses;
                return {
                  teamSize: init.teamSize,
                  website: init.website,
                  brokerage: init.brokerage,
                  teamName: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  teamSize: "Pristine",
                  website: "Pristine",
                  brokerage: "Pristine",
                  teamName: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  teamSize: "Pristine",
                  website: "Pristine",
                  brokerage: "Pristine",
                  teamName: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateTeamSize: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTeamSizeField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateWebsite: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateWebsiteField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateBrokerage: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateBrokerageField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateTeamName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTeamNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurTeamSize: () => dispatch("BlurTeamSizeField"),
    blurWebsite: () => dispatch("BlurWebsiteField"),
    blurBrokerage: () => dispatch("BlurBrokerageField"),
    blurTeamName: () => dispatch("BlurTeamNameField"),
    teamSizeResult: Formality.exposeFieldResult(state.fieldsStatuses.teamSize),
    websiteResult: Formality.exposeFieldResult(state.fieldsStatuses.website),
    brokerageResult: Formality.exposeFieldResult(state.fieldsStatuses.brokerage),
    teamNameResult: Formality.exposeFieldResult(state.fieldsStatuses.teamName),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.teamSize;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.website;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.brokerage;
      if (typeof tmp$2 === "object") {
        return true;
      }
      let tmp$3 = match.teamName;
      return typeof tmp$3 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let Config = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertVariables = CreateTeamMarketingProfileMutation_graphql.Internal.convertVariables;

let convertResponse = CreateTeamMarketingProfileMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = CreateTeamMarketingProfileMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, CreateTeamMarketingProfileMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, CreateTeamMarketingProfileMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let initialInput = {
  teamName: "",
  brokerage: "",
  website: "",
  teamSize: ""
};

function messageToString(v) {
  if (v === "InvalidURL") {
    return "must be a valid URL";
  } else if (v === "IsRequired") {
    return "is required";
  } else {
    return "must be a number";
  }
}

function CreateTeamMarketingProfile$Form$FieldValidationMessage(props) {
  return JsxRuntime.jsx(FormalityUI.FieldValidationMessage.make, {
    messageToString: messageToString,
    result: props.result
  });
}

let FieldValidationMessage = {
  make: CreateTeamMarketingProfile$Form$FieldValidationMessage
};

function CreateTeamMarketingProfile$Form$InputField(props) {
  let status = props.status;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: props.labelText
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Form__Input.make, {
            type: props._type,
            onChange: props.onChange,
            onBlur: props.onBlur,
            status: FormalityUI.UIKitStatus.ofOptFieldResult(status),
            value: props.value
          }),
          Stdlib_Option.getOr(Stdlib_Option.map(props.helpText, text => JsxRuntime.jsx("div", {
            children: text,
            className: "text-base text-gray-500"
          })), null),
          JsxRuntime.jsx(CreateTeamMarketingProfile$Form$FieldValidationMessage, {
            result: status
          })
        ],
        className: "mt-2 sm:col-span-2 sm:mt-0 sm:max-w-xs space-y-3"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let InputField = {
  make: CreateTeamMarketingProfile$Form$InputField
};

function CreateTeamMarketingProfile$Form(props) {
  let router = Next.useRouter();
  let match = use();
  let mutate = match[0];
  let subpages = MarketingProfileSubpages.useTeamProfilePages(true, undefined);
  let nextPage = Stdlib_Option.getOrThrow(subpages[1], undefined);
  let form = useForm(initialInput, (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    mutate({
      input: {
        brokerage: Form__Helpers.opt_of_string(param.brokerage),
        teamName: param.teamName,
        teamSize: param.teamSize,
        website: param.website
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let result = param.createTeamMarketingProfile;
      if (result === undefined) {
        return notifyOnFailure();
      }
      if (result.__typename !== "TeamMarketingProfileCreated") {
        return notifyOnFailure();
      }
      notifyOnSuccess(undefined);
      Next.Router.replace(nextPage.path + `?is_new=1`, undefined, undefined, router);
    }, param => notifyOnFailure(), undefined);
  });
  let match$1 = form.status;
  let tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "SubmissionFailed" ? null : JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Alert.$$Error.make, {
        title: "There was an error creating your team profile. Please try again"
      }),
      className: "mb-4"
    });
  return JsxRuntime.jsx("form", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(CreateTeamMarketingProfile$Form$InputField, {
              onChange: event => form.updateTeamName((input, value) => ({
                teamName: value,
                brokerage: input.brokerage,
                website: input.website,
                teamSize: input.teamSize
              }), event.target.value),
              onBlur: param => form.blurTeamName(),
              value: form.input.teamName,
              status: form.teamNameResult,
              labelText: "Team name"
            }),
            JsxRuntime.jsx(CreateTeamMarketingProfile$Form$InputField, {
              onChange: event => form.updateBrokerage((input, value) => ({
                teamName: input.teamName,
                brokerage: value,
                website: input.website,
                teamSize: input.teamSize
              }), event.target.value),
              onBlur: param => form.blurBrokerage(),
              value: form.input.brokerage,
              status: form.brokerageResult,
              labelText: "Brokerage"
            }),
            JsxRuntime.jsx(CreateTeamMarketingProfile$Form$InputField, {
              onChange: event => form.updateWebsite((input, value) => ({
                teamName: input.teamName,
                brokerage: input.brokerage,
                website: value,
                teamSize: input.teamSize
              }), event.target.value),
              onBlur: param => form.blurWebsite(),
              value: form.input.website,
              status: form.websiteResult,
              labelText: "Website"
            }),
            JsxRuntime.jsx(CreateTeamMarketingProfile$Form$InputField, {
              onChange: event => form.updateTeamSize((input, value) => ({
                teamName: input.teamName,
                brokerage: input.brokerage,
                website: input.website,
                teamSize: value
              }), event.target.value),
              onBlur: param => form.blurTeamSize(),
              value: form.input.teamSize,
              status: form.teamSizeResult,
              labelText: "Team size",
              helpText: "Optional. Sharing the number of agents on your team will help us serve teams better.",
              _type: "number"
            })
          ],
          className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: tmp,
              role: "status"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ButtonsV5.Link.make, {
                  href: "/account/marketing_profile",
                  className: "",
                  children: "Cancel"
                }),
                JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                  disabled: form.submitting,
                  children: "Create profile"
                })
              ],
              className: "flex items-baseline gap-6"
            })
          ],
          className: "flex flex-col items-end"
        })
      ],
      className: "space-y-6"
    }),
    onSubmit: event => {
      event.preventDefault();
      form.submit();
    }
  });
}

let Form = {
  Config: Config,
  Mutation: Mutation,
  initialInput: initialInput,
  messageToString: messageToString,
  FieldValidationMessage: FieldValidationMessage,
  InputField: InputField,
  make: CreateTeamMarketingProfile$Form
};

function CreateTeamMarketingProfile$Header(props) {
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx("h2", {
        children: "Create team marketing profile",
        className: "text-zinc-800 text-3xl font-medium"
      }),
      JsxRuntime.jsx("p", {
        children: "Fill the form with at least your team name. We’ll then guide you to complete your team marketing profile.",
        className: "text-base text-zinc-500"
      })
    ],
    className: "space-y-2 border-b pb-2"
  });
}

let Header = {
  make: CreateTeamMarketingProfile$Header
};

function CreateTeamMarketingProfile(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(CreateTeamMarketingProfile$Header, {}),
        JsxRuntime.jsx(CreateTeamMarketingProfile$Form, {})
      ],
      className: "space-y-8 sm:space-y-0"
    }),
    className: "bg-white p-6 shadow-sm rounded space-y-8"
  });
}

let make = CreateTeamMarketingProfile;

exports.Form = Form;
exports.Header = Header;
exports.make = make;
/* commitMutation Not a pure module */
